/**
 * Desktop Mega Menu
 * PCヘッダーのメガメニューをhoverで開閉する
 */
document.addEventListener('DOMContentLoaded', () => {
  const megaMenus = document.querySelectorAll('.header__inline-menu details.giraffe-mega-menu');

  megaMenus.forEach((details) => {
    let closeTimer;

    /**
     * メニューにマウスが入った時
     * ・閉じるタイマーを解除
     * ・他のメガメニューを閉じる
     * ・対象のメガメニューを開く
     */
    details.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);

      megaMenus.forEach((otherDetails) => {
        if (otherDetails !== details) {
          otherDetails.removeAttribute('open');
        }
      });

      details.setAttribute('open', '');
    });

    /**
     * メニューからマウスが離れた時
     * メニュー内へのカーソル移動で即座に閉じないよう
     * 少し遅延させてから閉じる
     */
    details.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, 150);
    });

    /**
     * 遷移先を持つメニュー（ITEMS）をマウスでクリックした時
     * メニューはhoverで開いているので、開閉せずにページへ移動する
     * （キーボード操作のクリックは detail が 0 になるため、従来どおり開閉させる）
     */
    const summary = details.querySelector('summary[data-giraffe-menu-href]');

    if (summary) {
      summary.addEventListener('click', (event) => {
        if (event.detail === 0 || !window.matchMedia('(hover: hover)').matches) return;

        event.preventDefault();
        event.stopPropagation();
        window.location.href = summary.dataset.giraffeMenuHref;
      });
    }
  });

});